module.exports = __webpack_public_path__ + "img/openclaw.0b59a03c.svg";